import { CALL_API } from '../../api';
import * as ActionTypes from './team.actionTypes';
import schema from '../../api/schema';

export const invalidateTeam = (id) => (dispatch, getState) => {
  dispatch({
    type: ActionTypes.INVALIDATE_TEAM,
    payload: {
      id
    }
  });

  return dispatch(readTeam(id));
};

const readTeams = () => ({
  [CALL_API]: {
    types: [
      ActionTypes.READ_TEAMS_REQUEST,
      ActionTypes.READ_TEAMS_SUCCESS,
      ActionTypes.READ_TEAMS_FAILURE,
    ],
    endpoint: 'api/team/',
    schema: schema.teamsSchema,
    authorization: true,
  }
});

export const getTeams = () => (dispatch, getState) => {
  return dispatch(readTeams());
};

const readTeamsByChannel = (id) => ({
  [CALL_API]: {
    types: [
      ActionTypes.READ_TEAMS_REQUEST,
      ActionTypes.READ_TEAMS_SUCCESS,
      ActionTypes.READ_TEAMS_FAILURE,
    ],
    endpoint: `api/team/all/${id}`,
    schema: schema.teamsSchema,
    authorization: true,
  }
});

export const getTeamsByChannel = (id) => (dispatch, getState) => {
  return dispatch(readTeamsByChannel(id));
};

const readTeam = (id) => ({
  [CALL_API]: {
    types: [
      ActionTypes.READ_TEAM_REQUEST,
      ActionTypes.READ_TEAM_SUCCESS,
      ActionTypes.READ_TEAM_FAILURE,
    ],
    endpoint: `api/team/${id}`,
    schema: schema.teamSchema,
    authorization: true,
  },
  payload: {
    id
  }
});

export const getTeam = (id) => (dispatch, getState) => {
  // const team = getState().entities.team.byId[id];
  // if (team) {
  //   return Promise.resolve();
  // }
  return dispatch(readTeam(id));
};

const readTopTeams = () => ({
  [CALL_API]: {
    types: [
      ActionTypes.READ_TOP_TEAMS_REQUEST,
      ActionTypes.READ_TOP_TEAMS_SUCCESS,
      ActionTypes.READ_TOP_TEAMS_FAILURE,
    ],
    endpoint: `api/team/top/campaign`,
    schema: schema.topTeamsSchema,
    authorization: true,
  },
});

export const getTopTeams = () => (dispatch, getState) => {
  return dispatch(readTopTeams());
};

const doCreateTeam = (data) => ({
  [CALL_API]: {
    types: [
      ActionTypes.CREATE_TEAM_REQUEST,
      ActionTypes.CREATE_TEAM_SUCCESS,
      ActionTypes.CREATE_TEAM_FAILURE,
    ],
    endpoint: 'api/team/',
    schema: schema.teamSchema,
    authorization: true,
    requestInit: {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(data)
    },
  }
});

export const createTeam = (data) => (dispatch, getState) => {
  return dispatch(doCreateTeam(data));
};

const doUpdateTeam = (data) => ({
  [CALL_API]: {
    types: [
      ActionTypes.UPDATE_TEAM_REQUEST,
      ActionTypes.UPDATE_TEAM_SUCCESS,
      ActionTypes.UPDATE_TEAM_FAILURE,
    ],
    endpoint: `api/team/${data._id}`,
    schema: schema.teamSchema,
    authorization: true,
    requestInit: {
      method: 'PUT',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(data)
    },
  },
  payload: {
    id: data._id
  }
});

export const updateTeam = (data) => (dispatch, getState) => {
  return dispatch(doUpdateTeam(data));
};

const doDeleteTeam = (id) => ({
  [CALL_API]: {
    types: [
      ActionTypes.DELETE_TEAM_REQUEST,
      ActionTypes.DELETE_TEAM_SUCCESS,
      ActionTypes.DELETE_TEAM_FAILURE,
    ],
    endpoint: `api/team/${id}`,
    schema: schema.teamSchema,
    authorization: true,
    requestInit: {
      method: 'DELETE',
    },
  },
  payload: {
    id
  }
});

export const deleteTeam = (id) => (dispatch, getState) => {
  return dispatch(doDeleteTeam(id));
};


// WEBPACK FOOTER //
// ./src/modules/team/team.actions.js